import { AppData } from "../../types/app";

const app: AppData = {
  slug: "ddirong",
  name: "띠롱",
  summary: "완료한 일을 결과 메모로 남겨 주간보고와 고과 기록으로 모으는 웹 앱",
  category: "업무 도구",
  platforms: ["web"],
  status: "live",
  released_at: "2026-08-31",
  pinned: false,
  icon: "/apps/ddirong/icon.png",
  links: { web: "https://ddirong.com" },
  has_account: true,
  operator: { name: "이광복", email: "admin@ddirong.com" },
  role: "1인 개발, 기획부터 운영까지",
  why:
    "주간보고나 고과 시즌마다 지난 몇 달 동안 한 일을 다시 찾아야 했다. 띠롱은 할 일에 체크하는 순간 결과 메모를 묻고, 그 문장을 기간별로 이어 붙여 보고서 텍스트로 만든다. 기록에 있는 사실만 옮기고 문장을 다듬거나 보태지 않는 것이 원칙이다. 따로 마케팅하지 않았고, 지금은 회사 동료들이 쓰고 있다.",
  features: [
    { title: "완료할 때 묻는 결과 메모", body: "할 일을 완료하면 결과 메모 창이 바로 열린다. 할 일은 지연, 오늘, 예정, 언젠가로 나뉘고 반복 일정도 관리한다." },
    { title: "주간보고와 고과 텍스트", body: "완료 항목을 주차별로 묶고, 기간 통계와 함께 주간보고용, 고과용 텍스트를 정해진 형식으로 복사한다." },
    { title: "Google 캘린더 함께 보기", body: "할 일 기한과 Google 캘린더 일정을 한 화면에서 본다. 읽기 권한만 쓰고 일정은 저장하지 않는다." },
    { title: "공유 워크스페이스", body: "워크스페이스를 공유로 바꾸면 팀 백로그가 된다. 초대, 역할, 담당자 지정, 댓글, 알림, 데일리 스탠드업, 문서 관리가 있다." },
    { title: "PM 모드와 Interviewer 모드", body: "PM 모드는 프로젝트 산출물의 요청, 제출, 검수를 다룬다. Interviewer 모드는 이력서를 근거로 질문과 평가 초안을 만들고 면접 녹음을 전사한다. 승인 후 7일간 무료로 쓴다." },
  ],
  screenshots: [
    { src: "/apps/ddirong/og.png", alt: "띠롱 대표 이미지. 체크하면 주간보고가 한 줄씩 쌓인다는 문구" },
    { src: "/apps/ddirong/interviewer.jpg", alt: "Interviewer 모드에서 테스트용 이력서를 열고 질문 개수와 난이도를 고르는 화면" },
  ],
  policy: {
    privacy: {
      effective_at: "2026-11-01",
      previous: [
        { effective_at: "2026-09-26", note: "Google Analytics 도입에 따라 수집 항목, 처리 목적, 보유 기간, 처리 위탁과 국외 이전, 쿠키 항목을 고쳤습니다." },
        { effective_at: "2026-08-31", note: "최초 시행" },
      ],
      sections: [
        {
          id: "purpose",
          title: "개인정보의 처리 목적",
          body: [
            "띠롱(DDirong, https://ddirong.com)은 「개인정보 보호법」 제30조에 따라 다음 목적으로 개인정보를 처리합니다. 목적 외의 용도로는 이용하지 않으며, 목적이 바뀌면 미리 동의를 받습니다.",
            "계정 식별과 로그인 상태 유지. 할 일, 결과 메모, 문서를 저장하고 보여 주며 주간보고와 고과용 텍스트를 만드는 일. 공유 워크스페이스의 멤버 관리, 알림과 웹푸시 발송. 캘린더 탭에 이용자의 Google 캘린더 일정을 보여 주는 일. PM 모드의 제출 파일 관리. Interviewer 모드의 이력서 분석, 질문과 평가 초안 생성, 녹음 전사. PM과 Interviewer 사용 요청의 검토와 연락. 장애 대응과 부정 이용 확인. 페이지별 이용 통계 파악.",
            "Google 캘린더 권한(calendar.readonly)은 캘린더 탭에 이용자 본인의 Google 기본 캘린더 일정을 보여 주는 목적으로만 씁니다. 일정은 탭을 열 때마다 Google에서 읽어 화면으로 보내고, 일정 ID, 제목, 시작, 종료, 종일 여부 외의 필드는 받지 않으며 데이터베이스에 저장하지 않습니다. 조회에 쓰는 Google 액세스 토큰은 서버 메모리에만 최대 약 1시간 두고, 서버에는 조회용 Google 갱신 토큰 하나만 저장합니다. 일정을 만들거나 고치거나 지우는 권한은 요청하지 않고, Gmail이나 드라이브 등 다른 Google 서비스의 데이터에는 접근하지 않습니다.",
            "Google API로 받은 정보의 사용과 전송은 Limited Use 요건을 포함한 Google API Services User Data Policy를 따릅니다. 캘린더 데이터는 다른 이용자나 제3자에게 넘기지 않고, 광고에 쓰지 않으며, AI 모델로 보내거나 학습에 쓰지 않습니다. 이용자의 동의가 있거나 보안 사고 조사, 법령 준수에 필요한 경우가 아니면 사람이 열람하지 않습니다. 캘린더 일정은 공유 워크스페이스의 팀 캘린더와 연결되지 않고 본인 화면에만 나옵니다.",
            "이용 통계는 페이지와 유입 경로 단위로 보며 특정 이용자를 식별하거나 맞춤형 광고에 쓰지 않습니다.",
          ],
        },
        {
          id: "items",
          title: "처리하는 개인정보의 항목",
          body: [
            "회원 가입은 첫 Google 로그인 때 자동으로 이루어집니다. 요청하는 Google 권한은 openid, email, profile, calendar.readonly입니다.",
            "Interviewer 모드에 올리는 이력서와 녹음에는 이용자가 아닌 지원자의 개인정보가 들어 있습니다. 띠롱은 이 정보를 이용자의 면접 업무를 돕는 범위에서만 처리하며, 지원자 정보를 올리는 이용자는 관련 법령에 따른 처리 근거를 갖춰야 합니다.",
            "이름, 이메일 같은 계정 정보와 할 일, 메모, 문서 등 입력 내용, Google 캘린더 데이터는 Google Analytics로 보내지 않습니다.",
          ],
          table: {
            head: ["구분", "항목", "수집 시점"],
            rows: [
              ["필수(Google 로그인)", "이메일, 이름, Google 계정 식별자(sub), Google OAuth 갱신 토큰", "첫 로그인. 갱신 토큰은 다시 동의할 때 바뀜"],
              ["Google 캘린더 일정", "일정 ID, 제목, 시작, 종료, 종일 여부(저장하지 않음)", "캘린더 탭을 열 때 조회"],
              ["이용자 입력", "닉네임(선택), 언어, 알림 설정, 할 일과 결과 메모, 기한과 완료일, 반복 규칙, 문서와 버전, 폴더, 워크스페이스 이름, 댓글, 데일리, 팀 일정", "이용 중 입력할 때"],
              ["PM, Interviewer 사용 요청", "사용 목적, 회사명(선택), 연락 이메일", "사용을 요청할 때"],
              ["PM 모드", "산출물 제출 파일", "파일을 올릴 때"],
              ["Interviewer 모드(지원자 정보)", "이력서 원본과 분석 결과, 면접 녹음과 전사문, 평가", "이용자가 이력서를 올리거나 녹음할 때"],
              ["웹푸시(선택)", "푸시 구독 주소, 암호화 키(p256dh, auth), 시간대, 구독 당시 브라우저 정보(User-Agent)", "알림을 허용할 때"],
              ["자동 수집", "접속 일시, IP 주소, 인증 쿠키(refresh_token), 로그인 위조 방지 쿠키, 로그인 상태 표시 쿠키, 언어 쿠키", "서비스를 이용할 때"],
              ["Google Analytics", "방문 페이지 주소와 제목(초대, 공유 링크의 토큰과 utm 외 쿼리는 지움), 방문 일시, 직전 페이지, 가입 완료 사실, 브라우저, 운영체제, 기기 종류, 화면 크기, IP로 추정한 국가와 도시, 쿠키 _ga, _ga_579571Q72Y", "웹페이지를 열 때"],
            ],
          },
        },
        {
          id: "retention",
          title: "개인정보의 보유와 이용 기간",
          body: [
            "개인정보는 아래 기간 동안 보유하고, 기간이 끝나거나 이용자가 삭제를 요청하면 지체 없이 파기합니다.",
            "띠롱은 재화나 용역을 판매하지 않으므로 「전자상거래 등에서의 소비자보호에 관한 법률」에 따른 거래 기록 보존 의무가 없습니다.",
          ],
          table: {
            head: ["대상", "보유 기간"],
            rows: [
              ["계정 정보와 이용자 입력 데이터", "탈퇴할 때까지"],
              ["Google OAuth 갱신 토큰", "탈퇴할 때까지. 탈퇴 즉시 삭제"],
              ["Google 캘린더 일정", "저장하지 않음"],
              ["휴지통으로 옮긴 할 일과 문서", "삭제 후 30일"],
              ["알림", "생성 후 180일"],
              ["PM 제출 파일", "최신 제출본은 프로젝트나 계정을 지울 때까지, 이전 제출본 원본은 90일"],
              ["Interviewer 이력서 원본과 분석 결과", "이용자가 면접 완료를 처리할 때까지"],
              ["Interviewer 녹음, 전사문, 평가", "이용자가 지원자나 포지션을 지우거나 탈퇴할 때까지"],
              ["PM, Interviewer 사용 요청 정보", "요청을 처리할 때까지"],
              ["웹푸시 구독 정보", "알림을 끄거나 탈퇴할 때까지"],
              ["서버 접속 로그", "기록일로부터 최대 3개월"],
              ["Google Analytics", "이벤트 데이터 2개월, 방문자 식별자에 연결된 데이터 마지막 방문일로부터 14개월. 쿠키 _ga는 최대 2년"],
            ],
          },
        },
        {
          id: "third-party",
          title: "개인정보의 제3자 제공",
          body: [
            "띠롱은 이용자의 개인정보를 제3자에게 제공하거나 판매하지 않습니다. 법령에 특별한 규정이 있거나 수사기관이 법령에 정한 절차에 따라 요구하는 경우는 예외로 합니다.",
            "이용자가 직접 공유한 내용은 공유 범위 안의 사람이 볼 수 있습니다. 공유 워크스페이스의 승인된 멤버는 그 워크스페이스의 할 일, 문서, 댓글, 데일리, 팀 일정, 멤버 명단을 봅니다. 결과 메모는 담당자에게만 보입니다. 문서 공유 링크를 만들면 링크를 가진 누구나 그 문서를 볼 수 있으며, 링크는 이용자가 해제할 수 있습니다.",
          ],
        },
        {
          id: "outsourcing",
          title: "개인정보 처리의 위탁과 국외 이전",
          body: [
            "띠롱은 서비스 운영을 위해 아래 업체에 개인정보 처리를 맡깁니다. 계정 정보와 입력 데이터가 저장되는 데이터베이스는 대한민국 춘천에 있습니다.",
            "국외 이전은 이용자가 해당 기능을 쓸 때마다 네트워크로 전송하는 방식으로 이루어집니다. 각 업체는 위탁 업무를 처리하는 데 필요한 기간 동안만 정보를 보유하며, Google Analytics는 3항의 기간을 따릅니다. 업체별 연락처는 아래 표에 적었습니다.",
            "국외 이전을 원하지 않으면 다음과 같이 거부할 수 있습니다. Interviewer 모드를 쓰지 않으면 이력서와 녹음이 AI 처리 업체로 가지 않습니다. 브라우저 알림을 허용하지 않으면 푸시 서비스로 보내지 않습니다. Google Analytics는 7항의 방법으로 거부할 수 있고, 거부해도 서비스 이용에 제한이 없습니다. Cloudflare와 Google 로그인은 서비스 제공에 꼭 필요해 거부하면 서비스를 이용할 수 없습니다.",
          ],
          table: {
            head: ["업체", "위탁 업무", "이전 국가", "이전 항목", "연락처"],
            rows: [
              ["Oracle Corporation (Oracle Cloud Infrastructure)", "서버와 데이터베이스 호스팅", "대한민국(국외 이전 없음)", "서비스가 처리하는 개인정보 전체", "www.oracle.com/legal/privacy"],
              ["Cloudflare, Inc.", "DNS, 웹 트래픽 프록시와 TLS, 첨부 파일 저장(R2)", "미국 등 Cloudflare 데이터센터가 있는 국가", "서비스 이용 중 오가는 요청과 응답, IP 주소, PM 제출 파일, 이력서, 면접 녹음", "privacy@cloudflare.com"],
              ["Google LLC (Google 로그인, Calendar API)", "Google 계정 인증, 캘린더 일정 조회", "미국", "인증 코드, Google OAuth 갱신 토큰", "policies.google.com/privacy"],
              ["Google LLC (Google Analytics)", "웹사이트 이용 통계 분석", "미국 등 Google 데이터센터가 있는 국가", "2항의 Google Analytics 항목", "policies.google.com/privacy"],
              ["Google LLC (Vertex AI)", "Interviewer 모드의 면접 질문, 인재상 초안, 이력서 항목 추출, 평가 생성", "미국 등 Google 데이터센터가 있는 국가", "이력서 내용, 포지션 정보, 면접 전사문과 메모", "policies.google.com/privacy"],
              ["OpenRouter, Inc.", "Vertex AI 월 예산 초과나 호출 실패 시 같은 AI 처리", "미국 및 요청을 받는 모델 제공자의 국가", "이력서 내용, 포지션 정보, 면접 전사문과 메모", "openrouter.ai/privacy"],
              ["DeepInfra, Inc.", "면접 녹음의 음성 전사", "미국", "면접 녹음 오디오", "deepinfra.com/privacy"],
              ["브라우저 푸시 서비스 (Google, Mozilla, Apple 등 이용자 브라우저 제조사)", "웹푸시 알림 전달", "미국 등 각 제조사의 서버가 있는 국가", "푸시 구독 주소, 암호화된 알림 제목, 본문, 이동 주소", "각 브라우저 제조사의 개인정보처리방침"],
            ],
          },
        },
        {
          id: "destruction",
          title: "개인정보의 파기 절차와 방법",
          body: [
            "보유 기간이 지나거나 처리 목적을 이루면 지체 없이 파기합니다. 전자 파일은 복구할 수 없는 방법으로 지우며, 데이터베이스 레코드와 저장소의 파일, 백업본을 두는 경우 그 백업본까지 포함합니다. 휴지통, 알림, 이전 제출본은 매일 정해진 시각에 자동으로 지웁니다.",
            "탈퇴하면 계정 정보, Google 갱신 토큰, 개인 워크스페이스와 그 안의 할 일과 반복 규칙, 개인 문서와 폴더, 알림, 푸시 구독, Interviewer 포지션과 지원자 정보가 유예 기간 없이 즉시 삭제됩니다. 이력서, 녹음, PM 제출 파일 같은 저장소의 파일은 탈퇴 후 30일 안에 지웁니다.",
            "공유 워크스페이스에 남긴 할 일과 문서는 팀에 필요하므로 그대로 남고, 등록자 표시는 워크스페이스 소유자로 바뀌어 탈퇴한 이용자의 이름이나 이메일은 남지 않습니다. 소유하던 공유 워크스페이스는 먼저 가입한 관리자에게, 관리자가 없으면 먼저 가입한 멤버에게 넘어가며 남은 사람이 없으면 함께 삭제됩니다. 본인만 담당하던 항목의 결과 메모는 지웁니다.",
            "삭제한 데이터는 복구할 수 없습니다. 같은 Google 계정으로 다시 가입하면 이전 계정과 무관한 새 이용자로 처리됩니다.",
          ],
        },
        {
          id: "rights",
          title: "정보주체의 권리와 행사 방법",
          body: [
            "이용자는 언제든지 개인정보의 열람, 정정, 삭제, 처리 정지를 요구할 수 있습니다. 탈퇴는 서비스 화면의 계정 메뉴, 내 설정, 위험 구역의 회원 탈퇴에서 직접 할 수 있고, 그 밖의 요청은 9항의 이메일로 보내면 영업일 기준 3일 안에 답하고 지체 없이 조치합니다. 법정대리인이나 위임받은 사람도 대신 요청할 수 있습니다. 법령에 따라 처리를 계속해야 하는 경우에는 그 사유를 알려 드립니다.",
            "Google 캘린더 접근 권한은 Google 계정 설정의 서드파티 앱 및 서비스(https://myaccount.google.com/permissions)에서 언제든지 해제할 수 있습니다. 탈퇴하면 띠롱이 저장한 갱신 토큰은 지워지지만 Google 쪽의 권한 부여 기록은 이 메뉴에서 직접 해제해야 합니다.",
            "쿠키는 브라우저 설정에서 거부하거나 지울 수 있습니다. 인증 쿠키를 거부하면 로그인이 유지되지 않아 서비스를 이용할 수 없습니다. Google Analytics 수집만 거부하려면 Google 애널리틱스 차단 브라우저 부가기능(https://tools.google.com/dlpage/gaoptout)을 설치하면 됩니다. 광고 목적의 쿠키는 쓰지 않습니다.",
            "개인정보 침해에 대한 상담이나 피해 구제는 개인정보침해신고센터(118, privacy.kisa.or.kr), 개인정보분쟁조정위원회(1833-6972, www.kopico.go.kr), 대검찰청(1301, www.spo.go.kr), 경찰청(182, ecrm.police.go.kr)에 문의할 수 있습니다.",
          ],
        },
        {
          id: "security",
          title: "개인정보의 안전성 확보 조치",
          body: [
            "모든 통신에 HTTPS와 HSTS를 적용합니다. 인증 토큰은 자바스크립트가 읽을 수 없도록 HttpOnly, Secure, SameSite 속성을 붙인 쿠키로 관리하고 access 토큰 유효 시간은 15분입니다.",
            "데이터베이스는 외부에 포트를 열지 않고 내부 네트워크에서만 접근합니다. API는 서비스 도메인 한 곳에서 오는 요청만 받고, 파일 업로드는 허용된 경로와 크기를 서버에서 다시 검증합니다.",
            "Google 캘린더 액세스 토큰은 디스크에 쓰지 않고 서버 메모리에만 둡니다. 개인정보에 접근할 수 있는 인원은 운영자 본인으로 한정합니다.",
          ],
        },
        {
          id: "privacy-officer",
          title: "개인정보 보호책임자",
          body: [
            "개인정보 처리에 관한 업무를 총괄하고 관련 문의와 고충을 처리하는 책임자는 다음과 같습니다.",
            "개인정보 보호책임자: 이광복, admin@ddirong.com",
          ],
        },
        {
          id: "changes",
          title: "개인정보처리방침의 변경",
          body: [
            "이 방침은 2026년 11월 1일부터 적용됩니다. 법령이나 서비스가 바뀌어 내용을 고치면 시행 7일 전부터 이 페이지에 공지합니다. 이용자에게 불리하거나 중요한 변경은 30일 전부터 공지합니다.",
            "이번 개정에서는 코드에서 확인한 외부 처리 업체(Cloudflare, Vertex AI, OpenRouter, DeepInfra, 브라우저 푸시 서비스)와 PM, Interviewer 모드의 처리 항목과 보유 기간을 추가했습니다.",
          ],
        },
      ],
    },
    terms: {
      effective_at: "2026-11-01",
      previous: [{ effective_at: "2026-08-31", note: "최초 시행" }],
      sections: [
        {
          id: "purpose",
          title: "목적",
          body: [
            "이 약관은 띠롱(DDirong, https://ddirong.com)의 이용 조건과 절차, 이용자와 운영자의 권리와 의무를 정합니다. 띠롱은 개인 운영자 이광복이 비영리로 운영하는 웹 서비스입니다.",
          ],
        },
        {
          id: "definitions",
          title: "정의",
          body: [
            "서비스는 띠롱 웹사이트와 그 안의 할 일, 기록, 문서, 캘린더, 공유 워크스페이스, PM 모드, Interviewer 모드 기능을 말합니다. 이용자는 Google 계정으로 로그인해 서비스를 쓰는 사람을 말합니다. 워크스페이스는 할 일과 문서를 담는 공간이며, 공유 워크스페이스는 다른 이용자를 초대해 함께 쓰는 워크스페이스입니다. 콘텐츠는 이용자가 입력하거나 올린 글, 파일, 녹음을 말합니다.",
          ],
        },
        {
          id: "effect-and-changes",
          title: "약관의 효력과 변경",
          body: [
            "이 약관은 서비스 화면에 게시해 효력이 생깁니다. 운영자는 필요하면 약관을 바꿀 수 있고, 바뀐 약관은 시행 7일 전부터 이 페이지에 공지합니다. 이용자에게 불리하거나 중요한 변경은 30일 전부터 공지합니다.",
            "바뀐 약관에 동의하지 않으면 이용을 그만두고 탈퇴할 수 있습니다.",
          ],
        },
        {
          id: "service",
          title: "서비스의 제공과 변경",
          body: [
            "할 일, 기록, 주간보고와 고과 텍스트, 문서, 캘린더, 공유 워크스페이스 기능은 무료입니다. PM 모드와 Interviewer 모드는 서버 운영 비용이 들어 운영자의 승인을 받은 뒤 7일간 임시로 제공하며, 요금이나 유료 전환, 자동 결제는 없습니다.",
            "Interviewer 모드가 만드는 질문, 이력서 항목, 평가는 AI가 만든 참고용 초안입니다. 채용 판단은 이용자가 직접 내려야 합니다.",
            "운영자는 서비스의 내용을 바꿀 수 있습니다. 서비스 전체를 종료할 때는 최소 30일 전에 이 페이지에 게시해 이용자가 데이터를 옮길 수 있게 합니다.",
          ],
        },
        {
          id: "account",
          title: "계정",
          body: [
            "계정은 Google 로그인으로만 만들어집니다. 이용자는 자신의 Google 계정 보안에 책임을 지며, 계정이 도용된 사실을 알면 바로 운영자에게 알려야 합니다.",
            "만 14세 미만은 서비스를 이용할 수 없습니다. 만 14세 미만 아동의 개인정보 처리에는 법정대리인의 동의가 필요하지만 서비스는 그 동의를 확인하는 절차를 두고 있지 않습니다.",
            "이용자는 언제든지 내 설정의 회원 탈퇴에서 직접 탈퇴하거나 admin@ddirong.com으로 계정 삭제를 요청해 이용계약을 해지할 수 있습니다. 탈퇴 후 데이터 처리는 개인정보처리방침을 따르며, 삭제된 데이터는 복구할 수 없습니다.",
          ],
        },
        {
          id: "user-obligations",
          title: "이용자의 의무와 금지 행위",
          body: [
            "이용자는 다음 행위를 해서는 안 됩니다. 서비스나 서버에 대한 무단 접근, 방해, 과도한 자동화 요청. 타인의 권리를 침해하거나 법령을 위반하는 내용의 저장과 유통. 다른 이용자의 계정 도용이나 서비스 취약점 악용.",
            "Interviewer 모드에 지원자의 이력서나 녹음을 올리는 이용자는 관련 법령에 따른 동의 등 처리 근거를 갖춰야 하며, 녹음은 상대방에게 알린 뒤 진행해야 합니다.",
            "공유 워크스페이스의 초대 링크와 문서 공유 링크는 받을 사람에게만 전달해야 합니다.",
          ],
        },
        {
          id: "content-rights",
          title: "콘텐츠의 권리",
          body: [
            "이용자가 입력한 콘텐츠의 권리는 이용자에게 있습니다. 운영자는 서비스를 제공하는 데 필요한 저장, 표시, 백업 범위에서만 콘텐츠를 처리하고 다른 목적으로 열람하거나 이용하지 않습니다.",
            "공유 워크스페이스에 등록한 할 일과 문서는 함께 쓰는 팀의 기록이므로, 등록한 이용자가 탈퇴해도 워크스페이스에 남고 등록자는 워크스페이스 소유자로 바뀝니다.",
          ],
        },
        {
          id: "suspension",
          title: "서비스 중단과 이용 제한",
          body: [
            "설비 점검, 장애, 천재지변 등 부득이한 사유로 서비스가 일시 중단될 수 있으며 이 경우 사전 통지가 어려울 수 있습니다.",
            "운영자는 금지 행위가 확인되면 사전 통지 없이 해당 계정의 이용을 제한하거나 계정을 삭제할 수 있습니다. PM 모드와 Interviewer 모드의 임시 사용 기간이 끝나면 해당 기능의 이용이 멈춥니다.",
          ],
        },
        {
          id: "liability",
          title: "책임의 제한",
          body: [
            "서비스는 있는 그대로 제공되며 운영자는 무중단 운영이나 데이터의 영구 보존을 보장하지 않습니다. 중요한 내용은 이용자가 따로 백업해 두어야 합니다.",
            "운영자는 천재지변, 정전, 호스팅 업체의 장애 등 통제할 수 없는 사유로 생긴 손해와 AI가 만든 초안을 이용자가 그대로 사용해 생긴 결과에 책임을 지지 않습니다. 운영자의 고의나 중대한 과실로 생긴 손해는 예외입니다.",
          ],
        },
        {
          id: "governing-law",
          title: "분쟁 해결과 준거법",
          body: [
            "이 약관은 대한민국 법에 따라 해석하고 적용합니다. 서비스 이용과 관련한 분쟁은 민사소송법에 따른 관할 법원에 소를 제기할 수 있습니다.",
            "문의와 분쟁 조정 요청은 admin@ddirong.com으로 보내 주시면 영업일 기준 3일 안에 답합니다.",
          ],
        },
      ],
    },
  },
  faq: [
    {
      q: "Google 캘린더 일정을 저장하나요?",
      a: "저장하지 않습니다. 캘린더 탭을 열 때 읽기 전용 권한으로 기본 캘린더를 조회해 화면에만 보여 줍니다. 서버에 남는 것은 조회에 쓰는 Google 갱신 토큰 하나이고, 탈퇴하면 지워집니다.",
    },
    {
      q: "캘린더 일정을 수정하거나 지울 수 있나요?",
      a: "안 됩니다. 요청하는 권한이 calendar.readonly 하나뿐이라 일정을 읽기만 합니다.",
    },
    {
      q: "주간보고는 어떻게 만들어지나요?",
      a: "할 일을 완료할 때 남긴 결과 메모를 기간별로 이어 붙여 정해진 형식의 텍스트로 복사합니다. 문장을 다듬거나 내용을 보태지 않습니다.",
    },
    {
      q: "팀원이 초대 링크를 받으면 바로 들어오나요?",
      a: "링크로 들어오면 참여 신청 상태가 되고, 소유자나 관리자가 승인해야 내용을 볼 수 있습니다. 승인 전에는 워크스페이스 이름도 보이지 않습니다.",
    },
    {
      q: "탈퇴하면 팀에 남긴 기록은 어떻게 되나요?",
      a: "공유 워크스페이스의 할 일과 문서는 팀에 남고 등록자가 워크스페이스 소유자로 바뀝니다. 내가 소유한 공유 워크스페이스는 남은 관리자에게 넘어갑니다. 개인 데이터는 즉시 삭제되고 복구되지 않습니다.",
    },
    {
      q: "유료인가요?",
      a: "기록, 주간보고, 문서는 무료입니다. PM과 Interviewer 모드는 관리자 승인 후 7일간 쓸 수 있고 요금이나 자동 결제는 없습니다.",
    },
  ],
  deletion: {
    in_app_steps: [
      "로그인 후 화면의 계정 메뉴를 열고 내 설정을 누릅니다.",
      "위험 구역의 회원 탈퇴에 본인 이메일을 정확히 입력하면 탈퇴 버튼이 켜집니다.",
      "탈퇴를 누르고 확인 창에서 한 번 더 승인하면 계정이 즉시 삭제되고 로그아웃됩니다.",
      "Google 쪽 권한까지 해제하려면 Google 계정 설정의 서드파티 앱 및 서비스(https://myaccount.google.com/permissions)에서 띠롱을 삭제합니다.",
    ],
    deleted: [
      { item: "계정 정보(이메일, 이름, Google 계정 식별자)", when: "즉시" },
      { item: "Google OAuth 갱신 토큰", when: "즉시" },
      { item: "개인 워크스페이스의 할 일, 반복 규칙, 결과 메모", when: "즉시" },
      { item: "개인 문서, 그림 문서, 폴더", when: "즉시" },
      { item: "알림과 웹푸시 구독 정보", when: "즉시" },
      { item: "Interviewer 포지션, 지원자, 전사문, 평가", when: "즉시" },
      { item: "저장소의 이력서, 녹음, PM 제출 파일", when: "탈퇴 후 30일 이내" },
    ],
    retained: [
      { item: "공유 워크스페이스에 등록한 할 일과 문서", period: "해당 워크스페이스가 유지되는 동안", basis: "팀 공용 기록. 등록자는 워크스페이스 소유자로 바뀌고 이름과 이메일은 남지 않습니다" },
      { item: "다른 담당자와 함께 맡은 완료 항목의 결과 메모", period: "해당 워크스페이스가 유지되는 동안", basis: "남은 담당자의 기록" },
      { item: "서버 접속 로그", period: "기록일로부터 최대 3개월", basis: "장애 대응과 부정 이용 확인" },
      { item: "Google Analytics 데이터", period: "이벤트 2개월, 방문자 데이터 14개월", basis: "Google Analytics 보관 설정. 계정과 연결되지 않은 방문자 식별자만 있습니다" },
    ],
  },
};

export default app;
